import { Form, Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import {
    BorrowersFilter,
    BorrowersStore,
} from 'src/stores/BorrowersStore/BorrowersStore';
import { FormHelper } from 'src/utils/FormHelper';
import styled from 'styled-components';

export const BorrowersHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <SearchPanel
            inputSearchFormName={formNames.getPath('filterSearch')}
            store={store}
            renderPanel={(props) => <FilterPanel {...props} />}
            inputSearchPlaceholder={t(
                'Page.Borrowers.AsideHeader.Search.Placeholder',
            )}
        />
    );
});

const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={(values: BorrowersFilter) => {
                store.pager.reset();
                store.filterCriteria?.applyFilter(
                    convertFormValuesToFilterCriteria(values),
                );
                store.loadList();
            }}
        >
            <StyledFormItem
                label={t('Page.Borrowers.Filter.BlacklistStatus')}
                name={formNames.getPath('filterBlacklisted')}
            >
                <Select allowClear data-testid="filterBlacklisted">
                    <Select.Option value="true" data-testid="true">
                        {t('data:status.borrower.BLACKLISTED')}
                    </Select.Option>
                    <Select.Option value="false" data-testid="false">
                        {t('data:status.borrower.NOT_BLACKLISTED')}
                    </Select.Option>
                </Select>
            </StyledFormItem>
            <StyledFormItem
                label={t('Page.Borrowers.Filter.HighRiskStatus')}
                name={formNames.getPath('filterHighRisk')}
            >
                <Select allowClear data-testid="filterHighRisk">
                    <Select.Option value="true" data-testid="true">
                        {t('data:status.borrower.HIGH_RISK')}
                    </Select.Option>
                    <Select.Option value="false" data-testid="false">
                        {t('data:status.borrower.NOT_HIGH_RISK')}
                    </Select.Option>
                </Select>
            </StyledFormItem>
        </SearchPanelFilterForm>
    );
});

const store = BorrowersStore;
const formNames = FormHelper.createNameProvider<BorrowersFilter>();

const convertFormValuesToFilterCriteria = (
    values: BorrowersFilter,
): BorrowersFilter => {
    return values;
};

const StyledFormItem = styled(Form.Item)`
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        display: flex;
        align-items: center;
        height: 2.7rem;
        border-radius: 0.5rem;
    }
`;
